import { render, staticRenderFns } from "./ReciboBase64.vue?vue&type=template&id=9585f4fa&scoped=true&"
import script from "./ReciboBase64.vue?vue&type=script&lang=js&"
export * from "./ReciboBase64.vue?vue&type=script&lang=js&"
import style0 from "./ReciboBase64.vue?vue&type=style&index=0&id=9585f4fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9585f4fa",
  null
  
)

export default component.exports